import { useState, useEffect } from 'react';
import type { BudgetApiClient } from '../api/client';
import type { TitleDetailsResponse } from '../types';

interface UseTitleDetailsResult {
  data: TitleDetailsResponse | null;
  isLoading: boolean;
  error: string | null;
}

export function useTitleDetails(
  apiClient: BudgetApiClient,
  titleId: string | null,
  type: 'E' | 'A'
): UseTitleDetailsResult {
  const [data, setData] = useState<TitleDetailsResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!titleId) {
      setData(null);
      setError(null);
      return;
    }

    let cancelled = false;
    setIsLoading(true);
    setError(null);

    apiClient
      .getTitleDetails(titleId, type)
      .then((result) => {
        if (!cancelled) {
          setData(result);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || 'Failed to fetch title details');
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [apiClient, titleId, type]);

  return { data, isLoading, error };
}
